/* eslint-disable no-else-return */
import { call, put } from 'redux-saga/effects';
import { api } from 'rp-auth';
import {
  fetchOfferInfoSuccess,
  fetchOfferInfoFailure,
} from '../actions/campaignOfferInfo';

const { getOfferInfo } = api;

function isValidOfferSubscriptionReference(listSubscriptionRef, selectedRef) {
  return listSubscriptionRef.includes(selectedRef);
}

function isOfferNotExpired(dateString) {
  // convert to timestamp number
  const currentTime = Number(new Date().getTime().toLocaleString('en-GB', { timeZone: 'Europe/London' }).replaceAll(',', ''));
  const expireDate = Number(new Date(dateString).getTime().toLocaleString('en-GB', { timeZone: 'Europe/London' }).replaceAll(',', ''));

  return expireDate >= currentTime;
}

// Gaussian/banker's rounding
function roundDiscountPrice(num, decimalPlaces) {
  const d = decimalPlaces || 0;
  // eslint-disable-next-line no-restricted-properties
  const m = Math.pow(10, d);
  const n = +(d ? num * m : num).toFixed(8); // Avoid rounding errors
  // eslint-disable-next-line one-var
  const i = Math.floor(n),
    f = n - i;
  const e = 1e-8; // Allow for rounding errors in f
  const r = (f > 0.499999999 - e && f < 0.500000001 + e) ?
    // eslint-disable-next-line eqeqeq
    ((i % 2 == 0) ? i : i + 1) : Math.round(n);
  return d ? r / m : r;
}

function calcOfferDetails(apiOffer, selectedOffer) {
  const { lowStart: { numberOfPeriods, percentage } } = apiOffer;

  const modifiedSelectedOffer = Object.assign({}, selectedOffer);

  // Example why we use toPrecision() : 349 - (349 * 70/100) = 104.69999999999999 ( must be 104.70 )
  const discountedPrice = parseFloat(modifiedSelectedOffer.price - (modifiedSelectedOffer.price * (percentage / 100))).toPrecision(6);


  modifiedSelectedOffer.originalPrice = selectedOffer.price;
  modifiedSelectedOffer.originalPeriod = selectedOffer.period;
  modifiedSelectedOffer.price = roundDiscountPrice(discountedPrice, 2);
  modifiedSelectedOffer.period = numberOfPeriods;

  return modifiedSelectedOffer;
}

export default function* (selectedsubReference, offerReference, session, selectedSubData) {
  try {
    const offerInfoData = yield call(getOfferInfo, offerReference, session);
    const { lowStart: { serviceReferences }, expiryDate, status } = offerInfoData;

    // check if offer is active
    if (status.toLowerCase() !== 'active') {
      throw new Error(`The offer ${offerReference} is invalid`);
    }

    // check if offer is expired
    if (!isOfferNotExpired(expiryDate)) {
      throw new Error(`The offer ${offerReference} is expired`);
    }

    // check if pre-selected subscription reference is valid for the pre-selected offer reference
    if (!isValidOfferSubscriptionReference(serviceReferences, selectedsubReference)) {
      throw new Error(`The Subscription ${selectedsubReference} is invalid for offer ${offerReference}`);
    }

    const calcOfferData = calcOfferDetails(offerInfoData, selectedSubData);

    const payload = {
      apiOffer: offerInfoData,
      selectedModOffer: calcOfferData,
    };

    yield put(fetchOfferInfoSuccess(payload));
    return payload;
  } catch (error) {
    console.error(error); // eslint-disable-line
    yield put(fetchOfferInfoFailure(error));
    return null;
  }
}
